tinymce.addI18n('zh_TW', {
  Redo: '\u91cd\u505a',
  Undo: '\u64a4\u92b7',
  Cut: '\u526a\u4e0b',
  Copy: '\u8907\u88fd',
  Paste: '\u8cbc\u4e0a',
  'Select all': '\u5168\u9078',
  'New document': '\u65b0\u6587\u4ef6',
  Ok: '\u78ba\u5b9a',
  Cancel: '\u53d6\u6d88',
  'Visual aids': '\u5c0f\u5e6b\u624b',
  Bold: '\u7c97\u9ad4',
  Italic: '\u659c\u9ad4',
  Underline: '\u4e0b\u5283\u7dda',
  Strikethrough: '\u522a\u9664\u7dda',
  Superscript: '\u4e0a\u6a19',
  Subscript: '\u4e0b\u6a19',
  'Clear formatting': '\u6e05\u9664\u683c\u5f0f',
  'Align left': '\u5de6\u908a\u5c0d\u9f4a',
  'Align center': '\u4e2d\u9593\u5c0d\u9f4a',
  'Align right': '\u53f3\u908a\u5c0d\u9f4a',
  Justify: '\u5de6\u53f3\u5c0d\u9f4a',
  'Bullet list': '\u9805\u76ee\u6e05\u55ae',
  'Numbered list': '\u6578\u5b57\u6e05\u55ae',
  'Decrease indent': '\u6e1b\u5c11\u7e2e\u6392',
  'Increase indent': '\u589e\u52a0\u7e2e\u6392',
  Close: '\u95dc\u9589',
  Formats: '\u683c\u5f0f',
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": '\u60a8\u7684\u700f\u89bd\u5668\u4e0d\u652f\u63f4\u5b58\u53d6\u526a\u8cbc\u7c3f\uff0c\u53ef\u4ee5\u4f7f\u7528\u5feb\u901f\u9375 Ctrl + X/C/V \u4ee3\u66ff\u526a\u4e0b\u3001\u8907\u88fd\u8207\u8cbc\u4e0a\u3002',
  Headers: '\u6a19\u984c',
  'Header 1': '\u6a19\u984c 1',
  'Header 2': '\u6a19\u984c 2',
  'Header 3': '\u6a19\u984c 3',
  'Header 4': '\u6a19\u984c 4',
  'Header 5': '\u6a19\u984c 5',
  'Header 6': '\u6a19\u984c 6',
  Headings: '\u6a19\u984c',
  'Heading 1': '\u6a19\u984c1',
  'Heading 2': '\u6a19\u984c2',
  'Heading 3': '\u6a19\u984c3',
  'Heading 4': '\u6a19\u984c4',
  'Heading 5': '\u6a19\u984c5',
  'Heading 6': '\u6a19\u984c6',
  Preformatted: '\u9810\u5148\u683c\u5f0f\u5316\u7684',
  Div: 'Div',
  Pre: 'Pre',
  Code: '\u4ee3\u78bc',
  Paragraph: '\u6bb5\u843d',
  Blockquote: '\u5f15\u6587\u5340\u584a',
  Inline: '\u5167\u806f',
  Blocks: '\u57fa\u584a',
  'Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.': '\u76ee\u524d\u5c07\u4ee5\u7d14\u6587\u5b57\u7684\u6a21\u5f0f\u8cbc\u4e0a\uff0c\u60a8\u53ef\u4ee5\u518d\u9ede\u9078\u4e00\u6b21\u53d6\u6d88\u3002',
  Fonts: '\u5b57\u578b',
  'Font Sizes': '\u5b57\u578b\u5927\u5c0f',
  Class: '\u985e\u578b',
  'Browse for an image': '\u5f9e\u5716\u7247\u4e2d\u700f\u89bd',
  OR: '\u6216',
  'Drop an image here': '\u62d6\u66f3\u5716\u7247\u81f3\u6b64',
  Upload: '\u4e0a\u50b3',
  Block: '\u5340\u584a',
  Align: '\u5c0d\u9f4a',
  Default: '\u9810\u8a2d',
  Circle: '\u7a7a\u5fc3\u5713',
  Disc: '\u5be6\u5fc3\u5713',
  Square: '\u6b63\u65b9\u5f62',
  'Lower Alpha': '\u5c0f\u5beb\u82f1\u6587\u5b57\u6bcd',
  'Lower Greek': '\u5e0c\u81d8\u5b57\u6bcd',
  'Lower Roman': '\u5c0f\u5beb\u7f85\u99ac\u6578\u5b57',
  'Upper Alpha': '\u5927\u5beb\u82f1\u6587\u5b57\u6bcd',
  'Upper Roman': '\u5927\u5beb\u7f85\u99ac\u6578\u5b57',
  'Anchor...': '\u9328\u9ede...',
  Name: '\u540d\u7a31',
  Id: 'Id',
  'Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.': 'Id\u61c9\u4ee5\u5b57\u6bcd\u958b\u982d\uff0c\u5f8c\u9762\u63a5\u8457\u5b57\u6bcd\uff0c\u6578\u5b57\uff0c\u7834\u6298\u865f\uff0c\u9ede\u6578\uff0c\u5192\u865f\u6216\u4e0b\u5283\u7dda\u3002',
  'You have unsaved changes are you sure you want to navigate away?': '\u7de8\u8f2f\u5c1a\u672a\u88ab\u5132\u5b58\uff0c\u4f60\u78ba\u5b9a\u8981\u96e2\u958b\uff1f',
  'Restore last draft': '\u8f09\u5165\u4e0a\u4e00\u6b21\u7de8\u8f2f\u7684\u8349\u7a3f',
  'Special character...': '\u7279\u6b8a\u5b57\u5143......',
  'Source code': '\u539f\u59cb\u78bc',
  'Insert/Edit code sample': '\u63d2\u5165/\u7de8\u8f2f \u7a0b\u5f0f\u78bc\u7bc4\u4f8b',
  Language: '\u8a9e\u8a00',
  'Code sample...': '\u7a0b\u5f0f\u78bc\u7bc4\u4f8b...',
  'Color Picker': '\u9078\u8272\u5668',
  R: '\u7d05',
  G: '\u7da0',
  B: '\u85cd',
  'Left to right': '\u5f9e\u5de6\u5230\u53f3',
  'Right to left': '\u5f9e\u53f3\u5230\u5de6',
  'Emoticons...': '\u8868\u60c5\u7b26\u865f\u2026',
  'Metadata and Document Properties': '\u5f8c\u8a2d\u8cc7\u6599\u8207\u6587\u4ef6\u5c6c\u6027',
  Title: '\u6a19\u984c',
  Keywords: '\u95dc\u9375\u5b57',
  Description: '\u63cf\u8ff0',
  Robots: '\u6a5f\u5668\u4eba',
  Author: '\u4f5c\u8005',
  Encoding: '\u7de8\u78bc',
  Fullscreen: '\u5168\u87a2\u5e55',
  Action: '\u52d5\u4f5c',
  Shortcut: '\u5feb\u901f\u9375',
  Help: '\u5e6b\u52a9',
  Address: '\u5730\u5740',
  'Focus to menubar': '\u8df3\u81f3\u9078\u55ae\u5217',
  'Focus to toolbar': '\u8df3\u81f3\u5de5\u5177\u5217',
  'Focus to element path': '\u8df3\u81f3HTML\u5143\u7d20\u5217',
  'Focus to contextual toolbar': '\u8df3\u81f3\u5feb\u6377\u9078\u55ae',
  'Insert link (if link plugin activated)': '\u65b0\u589e\u6377\u5f91 (\u6377\u5f91\u5916\u639b\u555f\u7528\u6642)',
  'Save (if save plugin activated)': '\u5132\u5b58 (\u5132\u5b58\u5916\u639b\u555f\u7528\u6642)',
  'Find (if searchreplace plugin activated)': '\u5c0b\u627e (\u5c0b\u627e\u53d6\u4ee3\u5916\u639b\u555f\u7528\u6642)',
  'Plugins installed ({0}):': '({0}) \u500b\u5916\u639b\u5df2\u5b89\u88dd\uff1a',
  'Premium plugins:': '\u52a0\u503c\u5916\u639b\uff1a',
  'Learn more...': '\u4e86\u89e3\u66f4\u591a...',
  'You are using {0}': '\u60a8\u6b63\u5728\u4f7f\u7528 {0}',
  Plugins: '\u5916\u639b',
  'Handy Shortcuts': '\u5feb\u901f\u9375',
  'Horizontal line': '\u6c34\u5e73\u7dda',
  'Insert/edit image': '\u63d2\u5165/\u7de8\u8f2f \u5716\u7247',
  'Image description': '\u5716\u7247\u63cf\u8ff0',
  Source: '\u5716\u7247\u7db2\u5740',
  Dimensions: '\u5c3a\u5bf8',
  'Constrain proportions': '\u7b49\u6bd4\u4f8b\u7e2e\u653e',
  General: '\u4e00\u822c',
  Advanced: '\u9032\u968e',
  Style: '\u6a23\u5f0f',
  'Vertical space': '\u9ad8\u5ea6',
  'Horizontal space': '\u5bec\u5ea6',
  Border: '\u908a\u6846',
  'Insert image': '\u63d2\u5165\u5716\u7247',
  'Image...': '\u5716\u7247......',
  'Image list': '\u5716\u7247\u6e05\u55ae',
  'Rotate counterclockwise': '\u9006\u6642\u91dd\u65cb\u8f49',
  'Rotate clockwise': '\u9806\u6642\u91dd\u65cb\u8f49',
  'Flip vertically': '\u5782\u76f4\u7ffb\u8f49',
  'Flip horizontally': '\u6c34\u5e73\u7ffb\u8f49',
  'Edit image': '\u7de8\u8f2f\u5716\u7247',
  'Image options': '\u5716\u7247\u9078\u9805',
  'Zoom in': '\u653e\u5927',
  'Zoom out': '\u7e2e\u5c0f',
  Crop: '\u88c1\u526a',
  Resize: '\u8abf\u6574\u5927\u5c0f',
  Orientation: '\u65b9\u5411',
  Brightness: '\u4eae\u5ea6',
  Sharpen: '\u92b3\u5316',
  Contrast: '\u5c0d\u6bd4',
  'Color levels': '\u984f\u8272\u5c64\u6b21',
  Gamma: '\u4f3d\u99ac\u503c',
  Invert: '\u53cd\u8f49',
  Apply: '\u61c9\u7528',
  Back: '\u5f8c\u9000',
  'Insert date/time': '\u63d2\u5165 \u65e5\u671f/\u6642\u9593',
  'Date/time': '\u65e5\u671f/\u6642\u9593',
  'Insert/Edit Link': '\u63d2\u5165/\u7de8\u8f2f\u9023\u7d50',
  'Insert/edit link': '\u63d2\u5165/\u7de8\u8f2f\u9023\u7d50',
  'Text to display': '\u986f\u793a\u6587\u5b57',
  Url: '\u7db2\u5740',
  'Open link in...': '\u958b\u555f\u9023\u7d50\u65bc...',
  'Current window': '\u76ee\u524d\u8996\u7a97',
  None: '\u7121',
  'New window': '\u53e6\u958b\u8996\u7a97',
  'Remove link': '\u79fb\u9664\u9023\u7d50',
  Anchors: '\u52a0\u5165\u9328\u9ede',
  'Link...': '\u9023\u7d50...',
  'Paste or type a link': '\u8cbc\u4e0a\u6216\u8f38\u5165\u9023\u7d50',
  'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?': '\u4f60\u6240\u586b\u5beb\u7684URL\u70ba\u96fb\u5b50\u90f5\u4ef6\uff0c\u9700\u8981\u52a0\u4e0amailto:\u524d\u7db4\u55ce\uff1f',
  'The URL you entered seems to be an external link. Do you want to add the required http:// prefix?': '\u4f60\u6240\u586b\u5beb\u7684URL\u5c6c\u65bc\u5916\u90e8\u93c8\u63a5\uff0c\u9700\u8981\u52a0\u4e0ahttp://:\u524d\u7db4\u55ce\uff1f',
  'Link list': '\u9023\u7d50\u6e05\u55ae',
  'Insert video': '\u63d2\u5165\u5f71\u97f3',
  'Insert/edit video': '\u63d2\u4ef6/\u7de8\u8f2f \u5f71\u97f3',
  'Insert/edit media': '\u63d2\u5165/\u7de8\u8f2f \u5a92\u9ad4',
  'Alternative source': '\u66ff\u4ee3\u5f71\u97f3',
  'Alternative source URL': '\u66ff\u4ee3\u4f86\u6e90URL',
  'Media poster (Image URL)': '\u5a92\u9ad4\u6d77\u5831\uff08\u5f71\u50cfImage URL\uff09',
  'Paste your embed code below:': '\u8acb\u5c07\u60a8\u7684\u5d4c\u5165\u5f0f\u7a0b\u5f0f\u78bc\u8cbc\u5728\u4e0b\u9762:',
  Embed: '\u5d4c\u5165\u78bc',
  'Media...': '\u5a92\u9ad4...',
  'Nonbreaking space': '\u4e0d\u5206\u884c\u7684\u7a7a\u683c',
  'Page break': '\u5206\u9801',
  'Paste as text': '\u4ee5\u7d14\u6587\u5b57\u8cbc\u4e0a',
  Preview: '\u9810\u89bd',
  'Print...': '\u5217\u5370...',
  Save: '\u5132\u5b58',
  Find: '\u641c\u5c0b',
  'Replace with': '\u66f4\u63db',
  Replace: '\u66ff\u63db',
  'Replace all': '\u66ff\u63db\u5168\u90e8',
  Previous: '\u4e0a\u4e00\u500b',
  Next: '\u4e0b\u4e00\u500b',
  'Find and replace...': '\u5c0b\u627e\u53ca\u53d6\u4ee3...',
  'Could not find the specified string.': '\u7121\u6cd5\u67e5\u8a62\u5230\u6b64\u7279\u5b9a\u5b57\u4e32',
  'Match case': '\u76f8\u5339\u914d\u6848\u4ef6',
  'Find whole words only': '\u50c5\u627e\u51fa\u5b8c\u6574\u5b57\u532f',
  'Spell check': '\u62fc\u5beb\u6aa2\u67e5',
  Ignore: '\u5ffd\u7565',
  'Ignore all': '\u5ffd\u7565\u6240\u6709',
  Finish: '\u5b8c\u6210',
  'Add to Dictionary': '\u52a0\u5165\u5b57\u5178\u4e2d',
  'Insert table': '\u63d2\u5165\u8868\u683c',
  'Table properties': '\u8868\u683c\u5c6c\u6027',
  'Delete table': '\u522a\u9664\u8868\u683c',
  Cell: '\u5132\u5b58\u683c',
  Row: '\u5217',
  Column: '\u884c',
  'Cell properties': '\u5132\u5b58\u683c\u5c6c\u6027',
  'Merge cells': '\u5408\u4f75\u5132\u5b58\u683c',
  'Split cell': '\u5206\u5272\u5132\u5b58\u683c',
  'Insert row before': '\u63d2\u5165\u5217\u5728...\u4e4b\u524d',
  'Insert row after': '\u63d2\u5165\u5217\u5728...\u4e4b\u5f8c',
  'Delete row': '\u522a\u9664\u5217',
  'Row properties': '\u5217\u5c6c\u6027',
  'Cut row': '\u526a\u4e0b\u5217',
  'Copy row': '\u8907\u88fd\u5217',
  'Paste row before': '\u8cbc\u4e0a\u5217\u5728...\u4e4b\u524d',
  'Paste row after': '\u8cbc\u4e0a\u5217\u5728...\u4e4b\u5f8c',
  'Insert column before': '\u63d2\u5165\u6b04\u4f4d\u5728...\u4e4b\u524d',
  'Insert column after': '\u63d2\u5165\u6b04\u4f4d\u5728...\u4e4b\u5f8c',
  'Delete column': '\u522a\u9664\u884c',
  'Cut column': '\u526a\u5207\u6b04',
  'Copy column': '\u8907\u88fd\u6b04',
  'Paste column before': '\u8cbc\u4e0a\u6b04\u4e4b\u524d',
  'Paste column after': '\u8cbc\u4e0a\u6b04\u4e4b\u5f8c',
  Cols: '\u6b04\u4f4d\u6bb5',
  Rows: '\u5217',
  Width: '\u5bec\u5ea6',
  Height: '\u9ad8\u5ea6',
  'Cell spacing': '\u5132\u5b58\u683c\u5f97\u9593\u8ddd',
  'Cell padding': '\u5132\u5b58\u683c\u7684\u908a\u8ddd',
  'Show caption': '\u986f\u793a\u6a19\u984c',
  Left: '\u5de6\u908a',
  Center: '\u4e2d\u9593',
  Right: '\u53f3\u908a',
  'Cell type': '\u5132\u5b58\u683c\u7684\u985e\u578b',
  Scope: '\u7bc4\u570d',
  Alignment: '\u5c0d\u9f4a',
  'H Align': '\u6c34\u5e73\u4f4d\u7f6e',
  'V Align': '\u5782\u76f4\u4f4d\u7f6e',
  Top: '\u7f6e\u9802',
  Middle: '\u7f6e\u4e2d',
  Bottom: '\u7f6e\u5e95',
  'Header cell': '\u6a19\u982d\u5132\u5b58\u683c',
  'Row group': '\u5217\u7fa4\u7d44',
  'Column group': '\u6b04\u4f4d\u7fa4\u7d44',
  'Row type': '\u884c\u7684\u985e\u578b',
  Header: '\u6a19\u982d',
  Body: '\u4e3b\u9ad4',
  Footer: '\u9801\u5c3e',
  'Border color': '\u908a\u6846\u984f\u8272',
  'Insert template...': '\u63d2\u5165\u6a23\u7248...',
  Templates: '\u6a23\u7248',
  Template: '\u6a23\u677f',
  'Text color': '\u6587\u5b57\u984f\u8272',
  'Background color': '\u80cc\u666f\u984f\u8272',
  'Custom...': '\u81ea\u8a02',
  'Custom color': '\u81ea\u8a02\u984f\u8272',
  'No color': 'No color',
  'Remove color': '\u79fb\u9664\u984f\u8272',
  'Table of Contents': '\u76ee\u9304',
  'Show blocks': '\u986f\u793a\u5340\u584a\u8cc7\u8a0a',
  'Show invisible characters': '\u986f\u793a\u96b1\u85cf\u5b57\u5143',
  'Word count': '\u8a08\u7b97\u5b57\u6578',
  Count: '\u8a08\u7b97',
  Document: '\u6587\u4ef6',
  Selection: '\u9078\u9805',
  Words: '\u5b57\u6578',
  'Words: {0}': '\u5b57\u6578\uff1a{0}',
  '{0} words': '{0} \u5b57\u5143',
  File: '\u6a94\u6848',
  Edit: '\u7de8\u8f2f',
  Insert: '\u63d2\u5165',
  View: '\u6aa2\u8996',
  Format: '\u683c\u5f0f',
  Table: '\u8868\u683c',
  Tools: '\u5de5\u5177',
  'Powered by {0}': '\u7531 {0} \u63d0\u4f9b',
  'Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help': '\u8c50\u5bcc\u7684\u6587\u672c\u5340\u57df\u3002\u6309ALT-F9\u524d\u5f80\u4e3b\u9078\u55ae\u3002\u6309ALT-F10\u547c\u53eb\u5de5\u5177\u6b04\u3002\u6309ALT-0\u5c0b\u6c42\u5e6b\u52a9',
  'Image title': '\u5716\u7247\u6a19\u984c',
  'Border width': '\u6846\u7dda\u5bec\u5ea6',
  'Border style': '\u6846\u7dda\u6a23\u5f0f',
  Error: '\u932f\u8aa4',
  Warn: '\u8b66\u544a',
  Valid: '\u6709\u6548',
  'To open the popup, press Shift+Enter': '\u8981\u958b\u555f\u5f48\u51fa\u8996\u7a97\uff0c\u8acb\u6309Shift+Enter',
  'Rich Text Area. Press ALT-0 for help.': '\u5bcc\u6587\u672c\u5340\u57df\u3002\u8acb\u6309ALT-0\u5c0b\u6c42\u5354\u52a9\u3002',
  'System Font': '\u7cfb\u7d71\u5b57\u578b',
  'Failed to upload image: {0}': '\u7121\u6cd5\u4e0a\u50b3\u5f71\u50cf\uff1a{0}',
  'Failed to load plugin: {0} from url {1}': '\u7121\u6cd5\u4e0a\u50b3\u63d2\u4ef6\uff1a{0}\u81eaurl{1}',
  'Failed to load plugin url: {0}': '\u7121\u6cd5\u4e0a\u50b3\u63d2\u4ef6\uff1a{0}',
  'Failed to initialize plugin: {0}': '\u7121\u6cd5\u555f\u52d5\u63d2\u4ef6\uff1a{0}',
  example: '\u7bc4\u4f8b',
  Search: '\u641c\u7d22',
  All: '\u5168\u90e8',
  Currency: '\u8ca8\u5e63',
  Text: '\u6587\u672c',
  Quotations: '\u5f15\u7528',
  Mathematical: '\u6578\u5b78',
  'Extended Latin': '\u62c9\u4e01\u5b57\u6bcd\u64f4\u5145',
  Symbols: '\u7b26\u865f',
  Arrows: '\u7bad\u982d',
  'User Defined': '\u4f7f\u7528\u8005\u5df2\u5b9a\u7fa9',
  'dollar sign': '\u7f8e\u5143\u7b26\u865f',
  'currency sign': '\u8ca8\u5e63\u7b26\u865f',
  'euro-currency sign': '\u6b50\u5143\u7b26\u865f',
  'colon sign': '\u79d1\u6717\u7b26\u865f',
  'cruzeiro sign': '\u514b\u9b6f\u8cfd\u7f85\u7b26\u865f',
  'french franc sign': '\u6cd5\u6717\u7b26\u865f',
  'lira sign': '\u91cc\u62c9\u7b26\u865f',
  'mill sign': '\u6587\u7b26\u865f',
  'naira sign': '\u5948\u62c9\u7b26\u865f',
  'peseta sign': '\u6bd4\u585e\u5854\u7b26\u865f',
  'rupee sign': '\u76e7\u6bd4\u7b26\u865f',
  'won sign': '\u97d3\u571c\u7b26\u865f',
  'new sheqel sign': '\u65b0\u8b1d\u514b\u723e\u7b26\u865f',
  'dong sign': '\u8d8a\u5357\u76fe\u7b26\u865f',
  'kip sign': '\u8001\u64be\u5e63\u7b26\u865f',
  'tugrik sign': '\u8499\u53e4\u5e63\u7b26\u865f',
  'drachma sign': '\u5fb7\u514b\u62c9\u99ac\u7b26\u865f',
  'german penny symbol': '\u5fb7\u570b\u5206\u7b26\u865f',
  'peso sign': '\u62ab\u7d22\u7b26\u865f',
  'guarani sign': '\u5df4\u62c9\u572d\u5e63\u7b26\u865f',
  'austral sign': '\u963f\u6839\u5ef7\u5e63\u7b26\u865f',
  'hryvnia sign': '\u70cf\u514b\u862d\u5e63\u7b26\u865f',
  'cedi sign': '\u8fe6\u7d0d\u5e63\u7b26\u865f',
  'livre tournois sign': '\u91cc\u5f17\u723e\u7b26\u865f',
  'spesmilo sign': '\u570b\u969b\u5e63\u7b26\u865f',
  'tenge sign': '\u54c8\u85a9\u514b\u5e63\u7b26\u865f',
  'indian rupee sign': '\u5370\u5ea6\u76e7\u6bd4\u7b26\u865f',
  'turkish lira sign': '\u571f\u8033\u5176\u91cc\u62c9\u7b26\u865f',
  'nordic mark sign': '\u5317\u6b50\u99ac\u514b\u7b26\u865f',
  'manat sign': '\u4e9e\u585e\u62dc\u7136\u5e63\u7b26\u865f',
  'ruble sign': '\u76e7\u5e03\u7b26\u865f',
  'yen character': '\u65e5\u5713\u7b26\u865f',
  'yuan character': '\u4eba\u6c11\u5e63\u7b26\u865f',
  'yuan character, in hong kong and taiwan': '\u6e2f\u5143\u8207\u53f0\u5e63\u7b26\u865f',
  'yen/yuan character variant one': '\u65e5\u5713/\u4eba\u6c11\u5e63\u7b26\u865f\u8b8a\u5316\u578b',
  'Loading emoticons...': '\u8f09\u5165\u8868\u60c5\u7b26\u865f\u2026',
  'Could not load emoticons': '\u7121\u6cd5\u8f09\u5165\u8868\u60c5\u7b26\u865f',
  People: '\u4eba',
  'Animals and Nature': '\u52d5\u7269\u8207\u81ea\u7136',
  'Food and Drink': '\u98f2\u98df',
  Activity: '\u6d3b\u52d5',
  'Travel and Places': '\u65c5\u884c\u8207\u5730\u9ede',
  Objects: '\u7269\u4ef6',
  Flags: '\u65d7\u6a19',
  Characters: '\u5b57\u5143',
  'Characters (no spaces)': '\u5b57\u5143\uff08\u7121\u7a7a\u683c\uff09',
  '{0} characters': '{0}\u5b57\u5143',
  'Error: Form submit field collision.': '\u932f\u8aa4\uff1a\u8868\u683c\u905e\u4ea4\u6b04\u4f4d\u885d\u7a81\u3002',
  'Error: No form element found.': '\u932f\u8aa4\uff1a\u627e\u4e0d\u5230\u8868\u683c\u5143\u7d20\u3002',
  Update: '\u66f4\u65b0',
  'Color swatch': '\u8272\u5f69\u6a23\u672c',
  Turquoise: '\u571f\u8033\u5176\u85cd',
  Green: '\u7da0\u8272',
  Blue: '\u85cd\u8272',
  Purple: '\u7d2b\u8272',
  'Navy Blue': '\u6df1\u85cd\u8272',
  'Dark Turquoise': '\u6df1\u571f\u8033\u5176\u85cd',
  'Dark Green': '\u6df1\u7da0\u8272',
  'Medium Blue': '\u4e2d\u85cd\u8272',
  'Medium Purple': '\u4e2d\u7d2b\u8272',
  'Midnight Blue': '\u9ed1\u85cd\u8272',
  Yellow: '\u9ec3\u8272',
  Orange: '\u6a59\u8272',
  Red: '\u7d05\u8272',
  'Light Gray': '\u6dfa\u7070\u8272',
  Gray: '\u7070\u8272',
  'Dark Yellow': '\u6df1\u9ec3\u8272',
  'Dark Orange': '\u6df1\u6a59\u8272',
  'Dark Red': '\u6697\u7d05\u8272',
  'Medium Gray': '\u4e2d\u7070\u8272',
  'Dark Gray': '\u6df1\u7070\u8272',
  'Light Green': '\u6de1\u7da0\u8272',
  'Light Yellow': '\u6dfa\u9ec3\u8272',
  'Light Red': '\u6dfa\u7d05\u8272',
  'Light Purple': '\u6dfa\u7d2b\u8272',
  'Light Blue': '\u6dfa\u85cd\u8272',
  'Dark Purple': '\u6df1\u7d2b\u8272',
  'Dark Blue': '\u6df1\u85cd\u8272',
  Black: '\u9ed1\u8272',
  White: '\u767d\u8272',
  'Switch to or from fullscreen mode': '\u8f49\u63db\u81ea/\u81f3\u5168\u87a2\u5e55\u6a21\u5f0f',
  'Open help dialog': '\u958b\u555f\u5354\u52a9\u5c0d\u8a71',
  history: '\u6b77\u53f2',
  styles: '\u6a23\u5f0f',
  formatting: '\u683c\u5f0f',
  alignment: '\u5c0d\u9f4a',
  indentation: '\u7e2e\u6392',
  'permanent pen': '\u6c38\u4e45\u6027\u7b46',
  comments: '\u8a3b\u89e3',
  'Format Painter': '\u8907\u88fd\u683c\u5f0f',
  'Insert/edit iframe': '\u63d2\u5165/\u7de8\u8f2fiframe',
  Capitalization: '\u5927\u5beb',
  lowercase: '\u5c0f\u5beb',
  UPPERCASE: '\u5927\u5beb',
  'Title Case': '\u5b57\u9996\u5927\u5beb',
  'Permanent Pen Properties': '\u6c38\u4e45\u6a19\u8a18\u5c6c\u6027',
  'Permanent pen properties...': '\u6c38\u4e45\u6a19\u8a18\u5c6c\u6027......',
  Font: '\u5b57\u578b',
  Size: '\u5b57\u5f62\u5927\u5c0f',
  'More...': '\u66f4\u591a\u8cc7\u8a0a......',
  'Spellcheck Language': '\u62fc\u5beb\u8a9e\u8a00',
  'Select...': '\u9078\u64c7......',
  Preferences: '\u9996\u9078\u9805',
  Yes: '\u662f',
  No: '\u5426',
  'Keyboard Navigation': '\u9375\u76e4\u5c0e\u822a',
  Version: '\u7248\u672c',
  Anchor: '\u52a0\u5165\u9328\u9ede',
  'Special character': '\u7279\u6b8a\u5b57\u5143',
  'Code sample': '\u7a0b\u5f0f\u78bc\u7bc4\u4f8b',
  Color: '\u984f\u8272',
  Emoticons: '\u8868\u60c5',
  'Document properties': '\u6587\u4ef6\u7684\u5c6c\u6027',
  Image: '\u5716\u7247',
  'Insert link': '\u63d2\u5165\u9023\u7d50',
  Target: '\u958b\u555f\u65b9\u5f0f',
  Link: '\u9023\u7d50',
  Poster: '\u9810\u89bd\u5716\u7247',
  Media: '\u5a92\u9ad4',
  Print: '\u5217\u5370',
  Prev: '\u4e0a\u4e00\u500b',
  'Find and replace': '\u5c0b\u627e\u53ca\u53d6\u4ee3',
  'Whole words': '\u6574\u500b\u55ae\u5b57',
  Spellcheck: '\u62fc\u5b57\u6aa2\u67e5',
  Caption: '\u8868\u683c\u6a19\u984c',
  'Insert template': '\u63d2\u5165\u6a23\u7248'
});